/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { View } from 'backbone.marionette';

import Session from '../../Session';
import getUserIdFromDn from '../../util/getUserIdFromDn';

import './TaskStatusAlertView.css';
import tmplTaskStatusAlertView from './TaskStatusAlertView.hbs';

const TaskStatusAlertView = View.extend({
  template: tmplTaskStatusAlertView,

  className: 'task-status-alert-view alert alert-info',

  attributes: {
    role: 'alert',
  },

  onBeforeRender() {
    const targets = this.model.get('targets');
    const completionDateMoment = this.model.get('completionDate');
    const isUnclaimed = this.model.get('isCreated');
    const isAssigned = this.model.get('isAssigned');
    const isAssigneeCurrentUser = this.model.get('assignee') === Session.user.userName;
    const isAssignedToCurrentUser = isAssigned && isAssigneeCurrentUser;
    const isAssignedToAnotherUser = isAssigned && !isAssigneeCurrentUser;
    const targetRole = _.find(targets, { type: 'role' });
    let targetRoleDn, targetRoleName;
    if (targetRole) {
      targetRoleDn = targetRole.targetDn;
      targetRoleName = getUserIdFromDn(targetRoleDn);
    }
    let completionDate;
    if (completionDateMoment && completionDateMoment.isValid()) {
      completionDate = completionDateMoment.format('MMMM Do YYYY, h:mm A');
    }
    this.model.set({
      isUnclaimed,
      isAssignedToCurrentUser,
      isAssignedToAnotherUser,
      targetRoleName,
      completionDate,
    });
  },

  onRender() {
    const isAssignedToCurrentUser = this.model.get('isAssignedToCurrentUser');
    if (isAssignedToCurrentUser) {
      this.$el.hide();
    }
  },
});

export default TaskStatusAlertView;
